import { useContext, useEffect, useState } from 'react'
import { t } from 'ttag'
import { isObjectLike } from 'lodash'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'

import { api } from '@h2/api'
import { AutoSuggest } from '@h2/components/inputs/autoSuggest'
import { Globals } from '@h2/globals'
import { useForm } from '@h2/common/components/hooks/useForm'
import { gap } from '@h2/common/components/page'
import { Button } from '@h2/components/buttons/button'
import { Field } from '@h2/components/inputs/field'
import { Flex } from '@h2/components/layout/flex'
import { showUserFeedback } from '@h2/common/actions/showUserFeedback'

const UserSearch = ({ addFn, isAdding, isManager }) => {
  const [userSearchResults, setUserSearchResults] = useState([])
  const reduxDispatch = useDispatch()
  const { register, value, dispatch, error, handleOnSubmit } = useForm({
    user(form) {
      if (!form.user) {
        return t`You must select a user`
      }
    }
  })
  const { userProfile } = useContext(Globals)

  useEffect(() => {
    const retrieve = async () => {
      const queryString = isManager ? `?isManager=true` : ''
      const data = await api.fetch(`/admin/users/search/suggest/users${queryString}`, {
        method: 'POST',
        version: 'v1',
        body: JSON.stringify(value.user)
      })

      setUserSearchResults(data.map(rslt => ({ label: rslt.name, value: rslt })))
    }

    if (value.user?.length > 1 && !isObjectLike(value.user)) {
      retrieve()
    } else {
      setUserSearchResults([])
    }
  }, [value.user, setUserSearchResults, userProfile.id, isManager])
  const { mutate: submitForm } = useMutation(
    form => {
      if (form.user.value) {
        const { id: userId } = form.user.value

        return addFn(userId)
      }

      return null
    },
    {
      onSuccess: () => {
        dispatch({ type: 'update', payload: {} })
      },
      onError: () => {
        reduxDispatch(
          showUserFeedback(
            t`An error occurred while trying to remove user from group`,
            'error'
          )
        )
      }
    }
  )

  return (
    <form onSubmit={handleOnSubmit(form => submitForm(form))}>
      <Flex gap={gap}>
        <Field
          isRequired={true}
          label={t`User to Add`}
          desc={error.user}
          status={error.user ? 'error' : 'default'}
          style={{ width: '100%' }}>
          <AutoSuggest
            id="type-suggest"
            labelledBy="type-suggest"
            placeholder={t`Start typing for suggestions...`}
            items={userSearchResults}
            {...register('user', { required: true })}
          />
        </Field>
        <Flex alignItems="flex-end">
          <Button isLoading={isAdding} size="large" type="submit">
            {t`Add User`}
          </Button>
        </Flex>
      </Flex>
    </form>
  )
}

export { UserSearch }
